// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var DateUtils = require("../DateUtils.bs.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var toString = include.toString;

var decode = include.decode;

var encode = include.encode;

function decode$1(json) {
  return Curry._2(Json.Decode.$less$pipe$great, Curry._1(decode, json), Curry._2(Json.Decode.$great$great$eq, Relude_Result.map((function (param) {
                        return Relude_Globals.$great$great(Relude_Int.toString, (function (prim) {
                                      return prim;
                                    }), param);
                      }), Json.Decode.intFromNumberOrString(json)), decode));
}

function isOrientationShift(param) {
  return Relude_Globals.$great$great(toString, (function (param) {
                switch (param) {
                  case "175" :
                  case "176" :
                      return true;
                  default:
                    return false;
                }
              }), param);
}

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode$1, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromString = include.fromString;

var Id_compare = include.compare;

var Id_eq = include.eq;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromString: Id_fromString,
  toString: toString,
  encode: encode,
  compare: Id_compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  decode: decode$1,
  isOrientationShift: isOrientationShift,
  GraphQL_API: GraphQL_API
};

var partial_arg = Relude_Option.reject(Curry._1(Relude_Int.OrdNamed.lessThanOrEq, 0));

function fromInt(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(Relude_Globals.id, Relude_Option.pure, param);
              }), partial_arg, param);
}

var include$1 = TypeUtils.MakeCustomOpaqueIntType({
      fromInt: fromInt,
      toInt: Relude_Globals.id
    });

var toString$1 = include$1.toString;

function toString$2(percent) {
  return Curry._1(toString$1, percent) + "%";
}

var WorkerSubsidyPercent_fromInt = include$1.fromInt;

var WorkerSubsidyPercent_fromString = include$1.fromString;

var WorkerSubsidyPercent_toInt = include$1.toInt;

var WorkerSubsidyPercent_decode = include$1.decode;

var WorkerSubsidyPercent_encode = include$1.encode;

var WorkerSubsidyPercent_compare = include$1.compare;

var WorkerSubsidyPercent_eq = include$1.eq;

var WorkerSubsidyPercent_Ord = include$1.Ord;

var WorkerSubsidyPercent_Set = include$1.$$Set;

var WorkerSubsidyPercent_Map = include$1.$$Map;

var WorkerSubsidyPercent = {
  fromInt: WorkerSubsidyPercent_fromInt,
  fromString: WorkerSubsidyPercent_fromString,
  toInt: WorkerSubsidyPercent_toInt,
  decode: WorkerSubsidyPercent_decode,
  encode: WorkerSubsidyPercent_encode,
  compare: WorkerSubsidyPercent_compare,
  eq: WorkerSubsidyPercent_eq,
  Ord: WorkerSubsidyPercent_Ord,
  $$Set: WorkerSubsidyPercent_Set,
  $$Map: WorkerSubsidyPercent_Map,
  toString: toString$2
};

function canBusinessCancelShift(currentDatetime, cancelledAt, startDatetime) {
  if (Relude_Option.isNone(cancelledAt)) {
    return DateUtils.isBefore(undefined, undefined, startDatetime)(currentDatetime);
  } else {
    return false;
  }
}

function canBusinessEditShift(currentDatetime, cancelledAt, startDatetime) {
  if (!Relude_Option.isNone(cancelledAt)) {
    return false;
  }
  var arg = DateUtils.getDateWithAdjustedDuration(undefined, undefined, -4, undefined, undefined)(startDatetime);
  return DateUtils.isBefore(undefined, undefined, arg)(currentDatetime);
}

var Accessory;

var Accessories;

var BusinessBulkMessage;

var DressCode;

exports.Accessory = Accessory;
exports.Accessories = Accessories;
exports.BusinessBulkMessage = BusinessBulkMessage;
exports.DressCode = DressCode;
exports.Id = Id;
exports.WorkerSubsidyPercent = WorkerSubsidyPercent;
exports.canBusinessCancelShift = canBusinessCancelShift;
exports.canBusinessEditShift = canBusinessEditShift;
/* include Not a pure module */
